import { render, staticRenderFns } from "./VendorManagementBlacklist.vue?vue&type=template&id=4cb80d6a"
import script from "./VendorManagementBlacklist.vue?vue&type=script&lang=js"
export * from "./VendorManagementBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports